<template>
<div class="chapter">
<div class="inner_page">
<div id="title">
<p class="title1">Billy Bishop VC</p>
<p class="title2">Lone Wolf Hunter</p>
<p class="title2">The RAF Ace Re-examined</p>
<p class="title3">Peter Kilduff</p>
<p class="title2">Grub Street · London</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_title.vue?7fe5d903